import { render, staticRenderFns } from "./PrivacyBlock.vue?vue&type=template&id=73c74d12&scoped=true&"
import script from "./PrivacyBlock.vue?vue&type=script&lang=js&"
export * from "./PrivacyBlock.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyBlock.vue?vue&type=style&index=0&id=73c74d12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c74d12",
  null
  
)

export default component.exports